export default __webpack_public_path__ + "static/media/Sponsor_table_20220808.7ab612f6.png";